module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-packet-vehicle-category-list"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns large-offset-11 text-right"
  }, [_c('PacketVehicleCategoryModal', {
    on: {
      "itemUpdated": _vm.itemUpdated
    }
  })], 1)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('base-list', {
    ref: "list",
    attrs: {
      "component": _vm.component,
      "dataLoader": _vm.dataLoader,
      "showPerPageSelect": true
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-024b5523!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/PacketVehicleCategoryList.vue
// module id = 2097
// module chunks = 1